import React, { useState, useEffect} from "react";
import SimpleTable from "my-simple-react-table"
import { formatDate, formatStatus, permissionCssClass } from "../../../../../util/Helpers";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Button} from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import * as handlers from "../../../_redux/settings/settingsHandlers";
import TableSkeleton from "../../../../../util/TableSkeleton";
import NewWebhook from "./modals/NewWebhook";
import DeleteWebhook from "./modals/DeleteWebhook";
import EditWebhook from "./modals/EditWebhook";
import { Permissions, PermissionType } from "../../../../../util/Permissions";

const Webhook = _ => {
    
    const adminUser = useSelector( ({auth}) => (auth.user), shallowEqual);
    const dispatch = useDispatch();
    const webhooks = useSelector(({settings}) => settings.webhooks, shallowEqual);


    // Modal Operation State
    const [webhookState, setWebhookState] = useState({
        showNewModal: false, 
        showEditModal: false, 
        showDeleteModal: false, 
        webhook: null
    });
    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setWebhookState({[modal]: !webhookState[modal]})
    }
    
    const webhookAction = webhook => {
    
        return (<span style={{whiteSpace: "nowrap"}}>
                  <Button
                    title="Edit Webhook"
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.SETTINGS, PermissionType.UPDATE)}`}
                    onClick={_ => setWebhookState({...webhookState, showEditModal: true, webhook})}
                    
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                      <SVG
                        title="Edit Webhook"
                        src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                      />
                    </span>
                  </Button>
              
                  <Button
                    title="Delete Webhook"
                    className={`btn btn-icon btn-light btn-hover-danger btn-sm ${permissionCssClass(adminUser, Permissions.SETTINGS, PermissionType.DELETE)}`}
                    disabled={true}
                    onClick={_ => setWebhookState({...webhookState, showDeleteModal: true, webhook})}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-danger">
                      <SVG 
                        title="Delete Webhook"
                        src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} 
                      />
                    </span>
                  </Button>
                </span>
            )
      }

    useEffect(() => {
        // Fetch All Webhooks
        dispatch(handlers.fetchWebhooks());
    }, [dispatch]);

    
    return <>
            { webhooks ? <div className="tab-pane active">
                            <div className={`text-right pt-4 ${permissionCssClass(adminUser, Permissions.SETTINGS)} ${permissionCssClass(adminUser, Permissions.SETTINGS, PermissionType.CREATE)}`}>
                                <button 
                                    className="btn btn-primary btn-sm"
                                    onClick={toggleModal("showNewModal")}
                                >
                                    <span className="svg-icon menu-icon mr-3">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Github.svg")}/>
                                    </span>
                                    New Webhook
                                </button>
                            </div>
                            <SimpleTable
                                data={webhooks}
                                columns={[
                                        {title:"URL", key: "url"}, 
                                        {title:"RETRY", format: row => formatStatus(row.retryStatus)},
                                        {title: "UPDATED AT", format: row => formatDate(row.updated)},
                                        {title: "CREATED AT", format: row => formatDate(row.created)},
                                        {title: "", format: webhookAction}
                                        ]} 
                                searchBox={false}
                            />
                        </div>
                        :
                        <TableSkeleton/>
            }

            <NewWebhook 
                show={webhookState.showNewModal}
                onHide={toggleModal("showNewModal")}
            />

            <EditWebhook
                show={webhookState.showEditModal}
                onHide={toggleModal("showEditModal")}
                webhook={webhookState.webhook}
            />

            <DeleteWebhook 
                show={webhookState.showDeleteModal}
                onHide={toggleModal("showDeleteModal")}
                webhook={webhookState.webhook}
            />
        </>
            
}

export default Webhook;